module.exports = __webpack_public_path__ + "images/7b273868dc18bc843414d86b9a962814.png";